import styled from '@emotion/styled';
import { ClassAttributes, createElement } from 'react';

interface Props {
  inverse?: boolean;
  className?: string;
}

const Logo = ({ inverse = false, className }: ClassAttributes<SVGElement> & Props) => (
  <Root viewBox="0 0 275 64" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path d="M0 50.863h63.55V63.55H0z" fill={inverse ? '#fff' : '#4C566C'} />

    <path
      d="M57.15 0H44.464v6.4h8.42L23.917 35.256 0 11.34v8.983L23.916 44.24l4.49-4.493 28.745-28.743v8.084h6.4V0"
      fill="#2DD28D"
    />

    <path
      d="M76.112 38.246h5.614v10.442l9.544-10.442h6.96L88.127 49.474c.898 1.235 2.47 3.48 4.828 6.736 2.358 3.257 4.042 5.727 5.277 7.41h-6.51l-7.41-9.992-2.584 2.807v7.186h-5.614V38.247zM119.79 63.62l-2.36-5.5h-10.665l-2.358 5.5h-5.95l10.89-25.262h5.502l10.89 25.263h-5.95zm-7.636-17.852l-3.144 7.3h6.288l-3.144-7.3zM128.772 38.246h5.614V63.51h-5.614M139.214 63.62v-3.93l13.25-16.504h-12.8v-4.94h20.546v3.93L146.96 58.68h13.475v4.94M183.564 38.246v5.052H170.99v5.165h11.34v4.828h-11.34v5.278h13.023v5.053h-18.638V38.247M206.694 38.246h5.614V63.51h-5.614L194.68 47.676V63.51h-5.614V38.245h5.277l12.463 16.28v-16.28M231.845 57.782l-2.47 5.84h-4.604l11.566-26.05h4.49l11.454 26.05h-4.716l-2.47-5.84h-13.25zm6.512-15.494l-4.94 11.565h9.88l-4.94-11.565zM274.286 63.62h-4.266v-3.368c-1.46 2.358-3.818 3.593-6.962 3.593-5.726 0-9.543-4.154-9.543-10.217 0-5.95 3.817-9.993 9.43-9.993 3.257 0 5.615 1.347 7.075 3.593V36h4.266v27.62zm-4.266-9.767c0-3.818-2.47-6.513-6.063-6.513-3.593 0-6.063 2.695-6.063 6.513 0 3.817 2.47 6.4 6.063 6.4 3.48 0 6.063-2.695 6.063-6.4z"
      fill={inverse ? '#fff' : '#4C566C'}
    />
  </Root>
);

const Root = styled('svg')({ width: 200, height: 'auto' });

export default Logo;
